import { render, staticRenderFns } from "./CatalogUpdateItemsNotFound.vue?vue&type=template&id=cffdcd78&scoped=true"
import script from "./CatalogUpdateItemsNotFound.vue?vue&type=script&lang=js"
export * from "./CatalogUpdateItemsNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffdcd78",
  null
  
)

export default component.exports